"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Debug = undefined;

var _debug =
/*#__PURE__*/
require("debug");

var _debug2 =
/*#__PURE__*/
_interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Debug = exports.Debug = function Debug(ns) {
  if (typeof ns !== 'string') throw new TypeError('Namespace should be a string');
  if (process.env.NODE_ENV === 'production') return function () {
    return undefined;
  };
  return (0, _debug2.default)(ns);
};